import * as React from "react";
const SvgArrowRightIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 10, viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 9L5 5L1 1", stroke: "#2D2D2D", strokeWidth: 1.5, strokeLinejoin: "round" }));
export default SvgArrowRightIcon;
